module.exports = __webpack_public_path__ + "static/img/tocImage2.0e8937fa.jpg";